<!--
 * @Description:
 * @Author: Rabbiter
 * @Date: 2023-03-08 20:38:49
-->
<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>

export default {
  name: 'App',
  created() {
    var token = this.$cookies.get("rb_token");
    var role = this.$cookies.get("rb_role");
    if (token == null || token == "" || role == null || role == null) {
      this.$router.push({path: '/'}) //跳转到首页
    }
  },
  // mounted() {
  //   autofit.init({
  //     el: '#app',
  //   });
  //   window.addEventListener('resize', () => {
  //     autofit.init({
  //       el: '#app',
  //     })
  //   })
  //
  //
  // },
  // beforeDestroy() {
  //   autofit.off()
  //   window.removeEventListener('resize', this.resize);
  // },
  // mounted() {
  //   autofit.init({
  //     designHeight: 929,
  //     designWidth: 1920,
  //     renderDom: "#app",
  //     resize: true
  //   }, false) // 可关闭控制台运行提示输出
  //   // 禁止Ctrl键加鼠标滚轮缩放
  //   document.addEventListener('mousewheel', this.forbidMouseWheelZoom, {passive: false});
  //
  //   // 禁止Ctrl键加键盘加减号缩放
  //   document.addEventListener('keydown', this.forbidKeyboardZoom, false);
  //
  //   // 禁止移动端双指缩放
  //   document.documentElement.addEventListener('touchstart', this.forbidTouchZoom, false);
  //
  //   // 禁止双击放大
  //   var lastTouchEnd = 0;
  //   document.documentElement.addEventListener('touchend', function (event) {
  //     var now = Date.now();
  //     if (now - lastTouchEnd <= 300) {
  //       event.preventDefault();
  //     }
  //     lastTouchEnd = now;
  //   }, false);
  // },
  // methods: {
  //   forbidMouseWheelZoom(event) {
  //     if (event.ctrlKey === true || event.metaKey === true) {
  //       event.preventDefault();
  //     }
  //   },
  //   forbidKeyboardZoom(event) {
  //     if ((event.ctrlKey === true || event.metaKey === true) &&
  //       (event.keyCode === 61 || event.keyCode === 107 ||
  //         event.keyCode === 173 || event.keyCode === 109 ||
  //         event.keyCode === 187 || event.keyCode === 189)) {
  //       event.preventDefault();
  //     }
  //   },
  //   forbidTouchZoom(event) {
  //     if (event.touches.length > 1) {
  //       event.preventDefault();
  //     }
  //   }
  // },
  // beforeDestroy() {
  //   // 页面销毁前移除事件监听
  //   document.removeEventListener('mousewheel', this.forbidMouseWheelZoom, {passive: false});
  //   document.removeEventListener('keydown', this.forbidKeyboardZoom, false);
  //   document.documentElement.removeEventListener('touchstart', this.forbidTouchZoom, false);
  // }
}
</script>

<style>
ul {
  list-style: none;
}

a {
  text-decoration: none;
}

* {
  margin: 0;
  padding: 0;
}

#app {
  font-family: "Microsoft YaHei", "Helvetica", "Tahoma", "Geneva", "Arial", sans-serif;
  background-color: #eee;
  max-height: 100vh;
}

#app::-webkit-scrollbar { /* 隐藏滚动条 */
  display: none; /* 对于WebKit浏览器 */
}

.main_wrapper::-webkit-scrollbar { /* 隐藏滚动条 */
  display: none; /* 对于WebKit浏览器 */
}

.box {
  position: relative;
}

.back-btn {
  position: absolute;
  right: 46px;
  top: -70px;
  cursor: pointer;
  font-size: 18px;
  color: #3a8ee6;

  &:hover {
    color: rgba(58, 142, 230, 0.6);
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue